/* eslint-disable @intercom/intercom/no-bare-strings */

import { assetUrl } from '@intercom/pulse/helpers/asset-url';
// The test suite can timeout when trying to load real images. In tests, lets use a Base64 1x1px image as a placeholder.
export const TEST_SUITE_PLACEHOLDER_IMAGE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=';
export const UPLOAD_IMAGE_PLACEHOLDER_RECTANGULAR = assetUrl('/@intercom/composer-ember/placeholder_rectangular_upload.svg');
export const UPLOAD_IMAGE_PLACEHOLDER_CIRCLE = assetUrl('/@intercom/composer-ember/placeholder_circle_upload.svg');
export const IMAGE_PLACEHOLDER_RECTANGULAR = assetUrl('/@intercom/composer-ember/placeholder_rectangular.svg');
export const IMAGE_PLACEHOLDER_CIRCLE = assetUrl('/@intercom/composer-ember/placeholder_circle.svg');
export const CALLOUT_BLOCK_ICON = assetUrl('/@intercom/composer-ember/callout_block_icon.svg');
export const PARAGRAPH_TEXT_SHORT = 'Be as short and simple as possible.';
export const PARAGRAPH_TEXT = 'Be as short and simple as possible. Focus on one key thing per text block.';
export const PARAGRAPH = {
  type: 'paragraph',
  text: PARAGRAPH_TEXT,
  class: 'no-margin'
};
export const SHORT_PARAGRAPH = {
  type: 'paragraph',
  text: PARAGRAPH_TEXT_SHORT,
  class: 'no-margin'
};
export const PLACEHOLDER_RECTANGULAR = {
  type: 'image',
  url: UPLOAD_IMAGE_PLACEHOLDER_RECTANGULAR,
  width: 250
};
export const PLACEHOLDER_BUTTON = {
  type: 'button',
  text: '',
  linkUrl: '',
  buttonStyle: 'solid'
};
export const PLACEHOLDER_CIRCLE = {
  type: 'image',
  url: UPLOAD_IMAGE_PLACEHOLDER_CIRCLE,
  width: 100,
  align: 'center'
};
export const TITLE_TEXT = 'Titles make the message clear';
export const PLACEHOLDER_TITLE = {
  type: 'heading',
  text: TITLE_TEXT,
  idAttribute: ''
};
export const LAYOUTS = {
  threeColumnsImageText: {
    type: 'table',
    responsive: true,
    stacked: true,
    container: false,
    rows: [{
      cells: [{
        content: [PLACEHOLDER_CIRCLE, SHORT_PARAGRAPH]
      }, {
        content: [PLACEHOLDER_CIRCLE, SHORT_PARAGRAPH]
      }, {
        content: [PLACEHOLDER_CIRCLE, SHORT_PARAGRAPH]
      }]
    }]
  },
  imageParagraphButton: {
    type: 'table',
    responsive: true,
    stacked: true,
    container: false,
    rows: [{
      cells: [{
        content: [PLACEHOLDER_RECTANGULAR]
      }, {
        content: [PARAGRAPH, PLACEHOLDER_BUTTON]
      }]
    }]
  },
  paragraphButtonImage: {
    type: 'table',
    responsive: true,
    stacked: true,
    container: false,
    rows: [{
      cells: [{
        content: [PARAGRAPH, PLACEHOLDER_BUTTON]
      }, {
        content: [PLACEHOLDER_RECTANGULAR]
      }]
    }]
  },
  twoColumnsTitleImageText: {
    type: 'table',
    responsive: true,
    stacked: true,
    container: false,
    rows: [{
      cells: [{
        content: [PLACEHOLDER_RECTANGULAR, PLACEHOLDER_TITLE, PARAGRAPH]
      }, {
        content: [PLACEHOLDER_RECTANGULAR, PLACEHOLDER_TITLE, PARAGRAPH]
      }]
    }]
  },
  textAndImage: {
    type: 'table',
    responsive: true,
    stacked: true,
    container: false,
    rows: [{
      cells: [{
        content: [PLACEHOLDER_TITLE, PARAGRAPH, PLACEHOLDER_BUTTON]
      }, {
        content: [PLACEHOLDER_RECTANGULAR]
      }]
    }]
  }
};